import { render } from "./CrawlClue.vue?vue&type=template&id=251db15d&scoped=true"
import script from "./CrawlClue.vue?vue&type=script&lang=js"
export * from "./CrawlClue.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-251db15d"

export default script